<div id="BackGround" [style]="cssBackGround">
    <div id="Dim" [style]="cssDim">
        <div class="msgbox">
            <img src="{{loadingURL}}" alt="Đang tải, vui lòng chờ..." title="Đang tải, vui lòng chờ..." width="200px"
                height="200px" />
        </div>
    </div>
</div>